<template>
    <div style="margin-bottom: 10px">
        <router-link target="_blank" :to="{name:'articleDetail',params: { id: articleInfo.articleId }}">
            <dt class="course-cover">
                <div class="img-box hover-img-scale-box">
                    <img :src="articleInfo.coverImgUrl" style="width:100%" alt="">
                </div>
            </dt>

            <dt class="classList-introduce">
                {{articleInfo.title}}
            </dt>
        </router-link>
    </div>
</template>

<script>
    import common from "../../mixin/common";

    export default {
        name: "ArticleListItem",
        mixins: [common],
        props: {
            articleInfo: Object,
        },
    }
</script>

<style scoped lang="less">

    .img-box {
        width: 100%;
        padding-top: 55%;
      border-radius: 10px 10px 0 0;
        position: relative;

        img {
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            height: 100%;
        }
    }

    /*@import "../../styles/course.less";*/

    @first-font-size: 16px;

    dt {
        /*margin: 6px 0;*/
        height: 22px;
        /*line-height: 22px;*/
    }

    dt:nth-of-type(1) {
        height: auto;
        margin-bottom: 6px;
    }

    /*  改  */
    .classList-introduce {
        padding: 0 8px;
        //height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 1; //显示的行
    }

    .classList-person {
        color: #888888;
    }

    .classList-price {
        color: orangered;
    }


    @media (max-width: 576px) {
        /*//<=768的设备   手机，paid */
        .classList-person {
            font-size: 13px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
        }

        @first-font-size: 14px;
        .free {
            font-size: 14px;
        }

        .discount-desc-phone {
            /*display: block;*/
        }

    }

    @media (max-width: 992px) {
        .discount-desc {
            display: none;
        }

        .discount-desc-phone {
            display: inline-block;
            float: left;
        }
    }

    @media (min-width: 768px) {
        /*//>=768的设备   ipadpro */

    }

    @media (min-width: 992px) {
        /*//>=992的设备   小屏电脑*/

    }

    @media (min-width: 1200px) {
        /*//>=1200的设备   电脑*/
    }

    @media (min-width: 1600px) {
        /*//>=1200的设备  大屏电脑*/

    }


</style>
